import { pushSimpleEvent } from "@nju/data-layer";

export const handleDataLayerAction = (category: string) => {
  switch (category) {
    case "start":
      pushSimpleEvent({
        event: "activity_menu",
        eventName: "category_start",
      });
      break;

    case "mój profil":
      pushSimpleEvent({
        event: "activity_menu",
        eventName: "category_my_profile",
      });
      break;

    case "moja usługa":
      pushSimpleEvent({
        event: "activity_menu",
        eventName: "category_service",
      });
      break;

    case "płatności":
      pushSimpleEvent({
        event: "activity_menu",
        eventName: "category_payment",
      });
      break;

    case "pomoc":
      pushSimpleEvent({
        event: "activity_menu",
        eventName: "category_faq",
      });
      break;

    default:
      return;
  }
};
